import { MutableRefObject, useEffect } from 'react';

import { useTimeout } from '@/hooks/useTimeout';

const setFocus = (ref: MutableRefObject<HTMLInputElement | null>) => {
  if (ref.current) {
    ref.current.focus();
  }
};

export const useFocus = (ref: MutableRefObject<HTMLInputElement | null>, deps?: []) => {
  const debouncedFocus = useTimeout(setFocus, 50);

  useEffect(() => {
    debouncedFocus(ref);
  }, [deps]);
};
